import React from 'react'

import Mark from './Mark'

// The house footer — nodejavascript.com site standard, part 4.
//
// THREE LINES, in this order: brand · links · copyright. The copyright carries the FULL
// DOMAIN NAME, which makes it the second place the origin is stated in full (the <title>
// is the first).
//
// 🔴 WHAT WAS MISSING HERE UNTIL 19 SEP 2026 — George: *"part of the rules are the header
// and footer, you forgot"*. This footer passed the automated check while being a different
// footer from every other site's: it carried NO MARK, its brand line read "Created by
// nodejavascript.com" with no site name in it, and the links line had no explicit link
// home. The one thing the rule exists for — that the nine read as one family — was absent
// from the only part every page has. The check reads four facts (a footer, a link home, the
// full domain, the door); it cannot see a missing mark, which is why the mark is held by
// the unit and end-to-end suites instead.
//
// The Cookie settings button is part of the rule too: the visitor's answer has to be
// changeable without hunting for it, and consent.js finds the door by id, so the id is part
// of the contract.
//
// 🔴 NO "BACK TO TOP" — George, 19 September 2026, verbatim: *"remeber this, to remove · back
// to top from footers"*. It was in the house template and it is not wanted in a footer: it is
// a control about the page rather than about the site, and the reader's own Home key already
// does it. Removed here and taken out of the template in the standard.
//
// 🔴 AND THE LINKS LINE DOES NOT REPEAT nodejavascript.com — George, 19 September 2026,
// verbatim: *"i like the top line, the second line remove nodejavascript between privacy and
// cookie settings"*. The brand line above already says it, and saying it twice in three lines
// is the redundancy he named. The links line carries only what the brand line does not: this
// site's own policy, and the door to the cookie answer.
const SiteFooter = () => {
  return (
    <footer className='dvs-footer'>
      <div className='dvs-footer-brand'>
        <span className='dvs-mark' aria-hidden='true'>
          <Mark />
        </span>
        <span>
          <b>password-please</b> · <a href='https://nodejavascript.com/'>nodejavascript.com</a>
        </span>
      </div>

      <p className='dvs-footer-links'>
        <a href='#privacy'>Privacy</a>
        {' · '}
        <button id='consentBtn' className='linkish' type='button'>
          Cookie settings
        </button>
      </p>

      <p className='dvs-footer-copy'>© 2026 password-please.nodejavascript.com. All rights reserved.</p>
    </footer>
  )
}

export default SiteFooter
